// @flow
import type { Match, RouterHistory } from 'react-router-dom';

import * as React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import colors from '../../../assets/css/colors';
// import Facebook from '../../../components/Icons/Facebook';
// import Twitter from '../../../components/Icons/Twitter';
import {
	// SocialLink,
	CountdownTimer,
} from '../../../components';
import * as selectors from '../../../modules/selectors';
import { below } from "../../../assets/css/media";

const TopBarWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 70px;
	width: 100%;
	background-color: #FFFFFF;

	.social-block {
		width: 1.5em;
		height: 1.5em;
	}

	${below.phone`
		.social-block {
			display: none;
		}
	`};
`;

const BarItem = styled.div`
	display: flex;
	height: 70px;
	align-items: center;
`;

const DraftTimerWrapper = styled.div`
	text-align: center;
	margin: 0 1.5em;

	p {
		margin-bottom: .5em;
		color: ${colors.nrlDarkGreenHover};
		font-size: 11px;
	}
`;

const TeamName = styled.h4`
	color: ${colors.nrlDarkGreen};
	margin-right: 1em;
`;

const UserAvatar = styled.img`
	height: 60px;
	width: 60px;
	border-radius: 50%;
	margin: 0 1.5em;
`;

const getUserAvatar = ({ avatar_version, id }) => {
	return process.env.REACT_APP_AVATARS_PATH + id + '.png?v=' + avatar_version;
};

type Props = {
	user: Object,
	league: Object,
	match: {
		...Match,
		params: {
			league_id: number
		}
	},
	history: RouterHistory,
	time_shift?: number,
};

class TopBarComponent extends React.Component<Props> {
	static defaultProps = {
		time_shift: 0
	};

	constructor(props) {
		super(props);

		_.bindAll(this, 'onTimerComplete');
	}


	onTimerComplete() {
		const
			{ match: { params: { league_id } } } = this.props,
			base_url = process.env.REACT_APP_BASE_URL || '';
		/**
		 * Added window.location instead of history.push because sometimes
		 * page doesn't want reload, probably due to some memory leak in timer component.
		 * So this is brut force solution.
		 */
		window.location = `${base_url}/league/${league_id}/team/live-draft`;
	}

	render() {
		const { user, league, time_shift } = this.props,
			initial_shift = 5 * 1000,
			draft_start_milliseconds = (new Date(league.draft_start)).valueOf(),
			draft_start_date = new Date(draft_start_milliseconds + initial_shift + time_shift);

		return (
			<TopBarWrapper>
				<BarItem>
					<UserAvatar src={getUserAvatar(user)} />
					<TeamName>{user.team_name}</TeamName>
					{/*Commented due to following ticket:*/}
					{/*https://fanhub.atlassian.net/browse/NRLDRAFT-531*/}
					{/*<SocialLink*/}
					{/*target="_blank"*/}
					{/*aria-label="Follow"*/}
					{/*className="social-block"*/}
					{/*border_color={colors.nrlGreen}*/}
					{/*>*/}
					{/*<Facebook size="1.2" />*/}
					{/*</SocialLink>*/}
					{/*<SocialLink*/}
					{/*target="_blank"*/}
					{/*aria-label="Twitter"*/}
					{/*className="social-block"*/}
					{/*border_color={colors.nrlGreen}*/}
					{/*>*/}
					{/*<Twitter size="1.2" />*/}
					{/*</SocialLink>*/}
				</BarItem>
				{league.draft_start ? (
					<BarItem>
						<DraftTimerWrapper>
							<p>DRAFT STARTS IN</p>
							<CountdownTimer
								date={draft_start_date.toString()}
								onComplete={this.onTimerComplete}
								showOnComplete={true}
							/>
						</DraftTimerWrapper>
					</BarItem>
				) : null}
			</TopBarWrapper>
		);
	}
}

const mapStateToProps = (state, props) => ({
	user: selectors.getUser(state),
	league: selectors.leagueDraft.getLeague(state, props),
});

export const TopBar = withRouter(
	connect(mapStateToProps)(TopBarComponent)
);

export default TopBar;


// WEBPACK FOOTER //
// ./src/pages/league/preDraft/topBar.js